
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.281","height":"31.785"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 735","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6992","d":"M23.756 10.624a.494.494 0 00-.226-.243l-7.373-3.845v-.9a.495.495 0 00-.989 0v.9l-5.6 2.921V4.784a4.784 4.784 0 00-9.567 0v26.507a.5.5 0 00.495.494h25.291a.5.5 0 00.495-.494V16.607a.491.491 0 00-.04-.2zM5.085 16.407a.5.5 0 00-.04.2v14.191H.99V4.783a3.794 3.794 0 017.589 0v5.189l-.783.408a.5.5 0 00-.226.243zm9.846 10.4l-3.665 3.362v-6.725zm-2.889-4h7.241l-3.62 3.321zm0 7.985l3.621-3.321 3.62 3.321zm8.017-.63l-3.665-3.355 3.665-3.362zm5.233.63h-4.243v-8.48a.489.489 0 00-.027-.153c0-.007 0-.013-.006-.019a.5.5 0 00-.092-.152s0-.007-.006-.009h-.005a.488.488 0 00-.147-.107l-.011-.006a.48.48 0 00-.169-.041h-9.847a.48.48 0 00-.167.04l-.013.007a.5.5 0 00-.146.106h-.005s0 .006-.006.009a.491.491 0 00-.091.152c0 .006 0 .013-.006.019a.487.487 0 00-.027.153v8.48H6.035V16.707l2.375-5.53 7.254-3.784 7.254 3.784 2.375 5.53z"}}),_c('path',{attrs:{"data-name":"Path 6993","d":"M18.713 11.589h-6.1a.5.5 0 00-.495.495v6.1a.5.5 0 00.495.495h6.1a.5.5 0 00.495-.495v-6.1a.5.5 0 00-.495-.495zm-.495 6.1h-5.111v-5.111h5.111z"}}),_c('path',{attrs:{"data-name":"Path 6994","d":"M6.392 3.817H3.177a.5.5 0 00-.495.495v5.053a.5.5 0 00.495.495h3.215a.5.5 0 00.495-.495V4.312a.5.5 0 00-.495-.495zM5.897 8.87H3.671V4.806h2.226z"}})])])
          )
        }
      }
    